(() => {
    const isHomepage = document.querySelector('[data-homepage]');
    const logo = document.querySelector('[data-dns-logo]');

    if (isHomepage && logo && logo.classList) {
        logo.classList.add('is-animated');

        setTimeout(() => {
            logo.classList.remove('is-animated');
        }, 2000);
    }
})();
